import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isLoginVisible, setIsLoginVisible] = useState(false);
  const [isRegisterVisible, setIsRegisterVisible] = useState(false);
  const [isResetPasswordVisible, setIsResetPasswordVisible] = useState(false);
  const [isUpdateProfileVisible, setIsUpdateProfileVisible] = useState(false);

  const showLoginModal = () => {
    setIsLoginVisible(true);
    setIsRegisterVisible(false);
    setIsResetPasswordVisible(false);
    setIsUpdateProfileVisible(false);
  };

  const showRegisterModal = () => {
    setIsLoginVisible(false);
    setIsRegisterVisible(true);
    setIsResetPasswordVisible(false);
    setIsUpdateProfileVisible(false);
  };

  const showResetPasswordModal = () => {
    setIsLoginVisible(false);
    setIsRegisterVisible(false);
    setIsResetPasswordVisible(true);
    setIsUpdateProfileVisible(false);
  };

  const showUpdateProfileModal = () => {
    setIsLoginVisible(false);
    setIsRegisterVisible(false);
    setIsResetPasswordVisible(false);
    setIsUpdateProfileVisible(true);
  };

  const hideModals = () => {
    setIsLoginVisible(false);
    setIsRegisterVisible(false);
    setIsResetPasswordVisible(false);
    setIsUpdateProfileVisible(false);
  };

  return (
    <AuthContext.Provider 
      value={{
        showLoginModal,
        showRegisterModal,
        showResetPasswordModal,
        showUpdateProfileModal,
        hideModals,
        isLoginVisible,
        isRegisterVisible,
        isResetPasswordVisible,
        isUpdateProfileVisible
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext; 